import { makeStyles } from '@material-ui/styles'
import Theme from '@refera/ui-core'

export default makeStyles(({ spacing, palette }) => ({
  headerButtons: {
    display: 'flex',
    gap: '8px',
  },
  alert: {
    margin: '-16px 0 20px',
  },
  container: {
    display: 'flex',
    width: '100%',
    height: '100%',
    flexDirection: 'column',
  },
  triageContainer: {
    width: '100%',
    padding: '32px',
  },
  subcontainer: {
    display: 'flex',
    position: 'relative',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '38px 22px 12px',
    marginBottom: '30px',
    flexDirection: 'column',
    border: `1px solid ${Theme.Colors.Grayscale.Twelve}`,
    borderRadius: '8px',
    gap: '24px',
  },
  modalContent: {
    justifyContent: 'unset',
  },
  wrapper: {
    display: 'grid',
    gridTemplateColumns: '320px 320px 320px',
    alignItems: 'start',
    marginRight: 'auto',
    width: '100%',
    gap: '44px',
    position: 'relative',
  },
  serviceOrderContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing(24),
    width: '100%',
  },
  serviceOrderDescription: {
    width: '100%',
    minHeight: spacing(96),
    maxHeight: spacing(220),
    overflowY: 'auto',
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word',
    border: `1px solid ${Theme.Colors.Grayscale.Twelve}`,
    borderRadius: '8px',
    padding: spacing(16),
    fontSize: spacing(15),
    lineHeight: 1.6,
    color: Theme.Colors.Grayscale.OneThousand,
    backgroundColor: Theme.Colors.Grayscale.White,
  },
  serviceOrderAttachments: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing(24),
    width: '100%',
  },
  floatingEditButton: {
    position: 'absolute',
    top: '-10px',
    left: '310px',
    zIndex: 1,
  },

  textAreaWrapper: {
    position: 'relative',
  },
  input: {
    maxWidth: '400px',
  },
  inputSize: {
    width: '100%',
  },
  select: {
    marginTop: '-16px',
  },
  inputLabel: {
    color: 'black',
    fontSize: '12px',
    fontWeight: '500',
    display: 'flex',
    gap: '4px',
  },
  selectWrapper: {
    marginTop: '20px !important',
  },
  asterisk: {
    color: Theme.Colors.Red.Base,
    marginLeft: '4px',
  },
  button: {
    height: '43px',
    width: '100px',
    padding: '10px 16px',
  },
  label: {
    top: '-8px',
    left: '14px',
    padding: '0px 6px',
    position: 'absolute',
    backgroundColor: 'white',
  },

  iconButton: {
    maxWidth: 'fit-content',
    height: 'fit-content',
    marginTop: '20px',
    '@media(max-width: 600px)': {
      marginTop: 0,
    },
  },
  editIcon: {
    fill: Theme.Colors.Grayscale.Eighty,
    width: '20.14px',
    height: '19.57px',
  },
  textArea: {
    width: '100%',
  },
  textAreaLabel: {
    display: 'flex',
    alignItems: 'center',
    gap: spacing(6),
    color: `${Theme.Colors.Grayscale.OneThousand} !important`,
    fontSize: spacing(12),
    marginBottom: spacing(8),
    fontWeight: 500,
    whiteSpace: 'normal',
  },
  confidenceToast: {
    appearance: 'none',
    border: 0,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: '40px',
    height: '20px',
    padding: '0 8px',
    borderRadius: '4px',
    fontSize: '12px',
    fontFamily: 'inherit',
    fontWeight: 700,
    lineHeight: 1,
    whiteSpace: 'nowrap',
    cursor: 'pointer',
  },
  aiExplanationDrawerContainer: {
    display: 'flex',
    '& .MuiDrawer-paper': {
      width: spacing(392),
      maxWidth: '100vw',
      top: spacing(48),
    },
    '& .MuiBackdrop-root': {
      backgroundColor: 'transparent',
    },
  },
  aiExplanationDrawer: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: Theme.Colors.Grayscale.White,
  },
  aiExplanationHeader: {
    padding: spacing(16, 10, 10, 32),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  aiExplanationHeaderTitle: {
    display: 'flex',
    alignItems: 'center',
  },
  aiExplanationIconWrapper: {
    width: spacing(32),
    height: spacing(32),
    fontSize: spacing(18),
    borderRadius: '50%',
    backgroundColor: Theme.Colors.Primary.Lightest,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: spacing(12),
  },
  aiExplanationIcon: {
    fill: Theme.Colors.Primary.Base,
    width: spacing(16),
    height: spacing(16),
  },
  aiExplanationTitle: {
    color: `${Theme.Colors.Primary.Base} !important`,
    fontWeight: '500 !important',
    lineHeight: 1.3,
  },
  aiExplanationCloseIcon: {
    width: spacing(24),
    height: spacing(24),
    fontSize: spacing(12),
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  aiExplanationDivider: {
    backgroundColor: Theme.Colors.Primary.Base,
  },
  aiExplanationContent: {
    padding: spacing(32),
    display: 'flex',
    flexDirection: 'column',
    gap: spacing(24),
    overflowY: 'auto',
  },
  aiExplanationSection: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing(10),
  },
  aiExplanationSectionTitle: {
    color: `${Theme.Colors.Primary.Base} !important`,
    fontSize: Theme.Typography.FontSize.XSmall,
    fontWeight: '500 !important',
    letterSpacing: 0,
  },
  aiExplanationConclusionCard: {
    border: `1px solid ${Theme.Colors.Grayscale.Twelve}`,
    borderRadius: '4px',
    padding: spacing(16),
    display: 'grid',
    gridTemplateColumns: '1fr auto',
    gap: spacing(8, 12),
    alignItems: 'center',
    backgroundColor: Theme.Colors.Grayscale.White,
  },
  aiExplanationConclusionLabel: {
    color: `${Theme.Colors.Grayscale.ThirtyTwo} !important`,
    fontSize: Theme.Typography.FontSize.Tiny,
    fontWeight: '500 !important',
  },
  aiExplanationConclusionValue: {
    gridColumn: '1 / 2',
    color: `${Theme.Colors.Grayscale.OneThousand} !important`,
    fontSize: Theme.Typography.FontSize.Small,
    fontWeight: '500 !important',
    wordBreak: 'break-word',
  },
  aiExplanationConfidenceBadge: {
    gridColumn: '2 / 3',
    gridRow: '1 / 3',
    minWidth: spacing(54),
    padding: spacing(6, 10),
    borderRadius: '4px',
    fontSize: spacing(13),
    fontWeight: 700,
    textAlign: 'center',
  },
  aiExplanationTriggerList: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: spacing(8),
  },
  aiExplanationTriggerTag: {
    padding: spacing(6, 10),
    borderRadius: '4px',
    border: `1px solid ${Theme.Colors.Grayscale.Twelve}`,
    backgroundColor: Theme.Colors.Grayscale.White,
    color: Theme.Colors.Grayscale.OneThousand,
    fontSize: spacing(12),
    fontWeight: 500,
    lineHeight: 1.2,
  },
  aiExplanationReasoningText: {
    color: `${Theme.Colors.Grayscale.OneThousand} !important`,
    fontSize: spacing(14),
    lineHeight: 1.6,
    whiteSpace: 'pre-wrap',
  },
  aiExplanationEmptyText: {
    color: `${Theme.Colors.Grayscale.Eighty} !important`,
    fontSize: spacing(13),
    lineHeight: 1.5,
  },
  formLabel: {
    '& .MuiFormControlLabel-label': {
      color: `${Theme.Colors.Grayscale.OneThousand} !important`,
      fontSize: spacing(12),
      fontWeight: 500,
    },
  },
  radioGroup: {
    marginBottom: spacing(16),
    display: 'flex',
    gap: spacing(20),
  },
  dateRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '20px',
    whiteSpace: 'nowrap',
  },
  required: {
    color: Theme.Colors.Red.Base,
    marginLeft: spacing(4),
    display: 'inline',
  },
  dateContent: {
    padding: 0,
    marginTop: '-3.6px !important',
    maxWidth: '160px',
    fontSize: '12px',
    '& .MuiInputLabel-root': {
      color: `${Theme.Colors.Grayscale.OneThousand} !important`,
      fontWeight: 500,
      top: '8px',
      position: 'absolute',
    },
  },
  dateColumn: {
    display: 'flex',
    flexDirection: 'column',
  },
  selectError: {
    borderBottom: Theme.Colors.Red.Base,
    '&:after': {
      borderBottomColor: Theme.Colors.Red.Base,
    },
  },
  errorTextAreaLabel: {
    color: Theme.Colors.Red.Base,
  },
  helper: {
    color: Theme.Colors.Red.Base,
    fontSize: '10px',
    marginTop: '4px',
  },
  labelContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    marginBottom: '8px',
  },
  errorLabel: {
    color: `${Theme.Colors.Red.Base} !important`,
  },
  errorMessage: {
    margin: 0,
    marginTop: spacing(2),
    color: `${palette.error.main} !important`,
    fontSize: spacing(10.5),
    fontFamily: 'Roboto',
    height: spacing(10),
  },
  flowHelpMessage: {
    margin: 0,
    marginTop: spacing(4),
    color: `${palette.text.primary} !important`,
    fontSize: spacing(12),
    fontFamily: 'Roboto',
  },
  thinErrorUnderline: {
    '&.MuiInputBase-root.Mui-error:after': {
      borderBottom: `1px solid ${palette.error.main} !important`,
      borderBottomWidth: '1px !important',
    },
    '&.MuiInputBase-root:after': {
      borderBottomWidth: '1px !important',
    },
  },
  actions: {
    gap: spacing(12),
    padding: spacing(8),
  },
}))
